<template>
  <v-card tile v-if="company !== null">
    <v-card-title>
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-space-between"
        >
          <span>Podjetje</span>
          <v-btn icon @click="editable = true" v-if="editable === false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="save" v-else>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-form :readonly="!editable">
            <h1>
              <v-text-field
                label="Naziv"
                v-model="company.title"
              ></v-text-field>
            </h1>
            <v-textarea
              label="Naslov"
              v-model="company.address"
              outlined
            ></v-textarea>
            <v-text-field
              label="Direktor"
              v-model="company.ceo"
            ></v-text-field>
            <v-text-field
              label="Matična številka"
              v-model="company.registration_number"
            ></v-text-field>
            <v-text-field
              label="Davčna številka"
              v-model="company.tax_number"
            ></v-text-field>
            <v-checkbox
              v-model="company.business_license_at"
              dense
              label="Potrdilo za delo v Avstriji (Bescheinigung bei BMDW (AT))"
            ></v-checkbox>
            <v-checkbox
              v-model="company.business_license_de"
              dense
              label="Potrdilo za delo v Nemčiji (Freistellungsbescheinigung)"
            ></v-checkbox>
            <v-checkbox
              v-model="company.business_license_si"
              dense
              label="Obrtno dovoljenje"
            ></v-checkbox>
            <v-checkbox
              v-model="company.vat_payer"
              dense
              label="DDV zavezanec"
            ></v-checkbox>
            <v-checkbox
              v-model="company.liability_insurance"
              dense
              label="Zavarovanje odgovornosti"
            ></v-checkbox>
            <v-checkbox
              v-model="company.ozs_member"
              dense
              label="Član OZS"
            ></v-checkbox>
            <v-checkbox
              v-model="company.resident_status"
              dense
              label="Urejen rezidentski status podjetja"
            ></v-checkbox>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      company: null,
      editable: false,
    }),
    mounted() {
      this.loadCompany();
    },
    methods: {
      loadCompany() {
        this.$http
          .get("api/v1/companies/" + this.$route.params.id)
          .then((response) => {
            this.company = response.data;
          });
      },
      save() {
        this.$http
          .put("api/v1/companies/" + this.$route.params.id, this.company)
          .then((response) => {
            this.company = response.data;
            this.editable = false;
          });
      },
    },
  };
</script>
<style></style>
